import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=642c7f4f&scoped=true"
import script from "./TextField.vue?vue&type=script&lang=ts"
export * from "./TextField.vue?vue&type=script&lang=ts"
import style0 from "./TextField.vue?vue&type=style&index=0&id=642c7f4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c7f4f",
  null
  
)

export default component.exports